import { render, staticRenderFns } from "./HtmlSnippets.vue?vue&type=template&id=4f4c6576"
import script from "./HtmlSnippets.vue?vue&type=script&lang=js"
export * from "./HtmlSnippets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports